<!--
Use this screen to enter payments FROM your bank account.
Note: To enter a payment FROM a supplier, use a negative Payment amount.
-->
<form [formGroup]="paymentForm" *ngIf="paymentForm">

	<!-- Payment type selector — same pill treatment as the AR payment program -->
	<div class="row mt-3">
		<div class="col-12">
			<div class="payment-method-header d-flex align-items-center justify-content-between flex-wrap mt-2 mb-2 px-2">
				<h4 class="payment-method-title m-0">Payment Method</h4>
			</div>
			<div class="payment-method-toggles-wrap">
				<mat-button-toggle-group #charge="matButtonToggleGroup" aria-label="Charge" (change)="setChargeType($event)" formControlName="payment_type" color="accent" class="payment-method-toggle-group">
					<mat-button-toggle [value]="method.paymentname" *ngFor="let method of payment_methods">{{method.paymentname}}</mat-button-toggle>
				</mat-button-toggle-group>
			</div>
		</div>
	</div>

	<!-- Form fields -->
	<div class="row mt-3">
		<div class="col-md-3">
			<mat-form-field appearance="outline" class="full-width">
				<mat-label>Date</mat-label>
				<input matInput formControlName="datepaid" [matDatepicker]="datepaid">
				<mat-datepicker-toggle matSuffix [for]="datepaid"></mat-datepicker-toggle>
				<mat-datepicker #datepaid></mat-datepicker>
			</mat-form-field>
		</div>
		<div class="col-md-3">
			<mat-form-field appearance="outline" class="full-width">
				<mat-label>Due Date</mat-label>
				<input matInput formControlName="dueDate" [matDatepicker]="dueDatePicker">
				<mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
				<mat-datepicker #dueDatePicker></mat-datepicker>
			</mat-form-field>
		</div>
		<div class="col-md-3">
			<mat-form-field appearance="outline" class="full-width">
				<mat-label>Bank Account</mat-label>
				<mat-select formControlName="bankaccount">
					<mat-option *ngFor="let method of bankaccounts" [value]="method.accountcode">{{method.bankaccountname}}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="col-md-3">
			<mat-form-field appearance="outline" class="full-width">
				<mat-label>Currency</mat-label>
				<mat-select formControlName="currcode">
					<mat-option *ngFor="let cur of currencies" [value]="cur.currabrev">{{ cur.currabrev }} – {{ cur.currency }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="col-md-3">
			<mat-form-field appearance="outline" class="full-width">
				<mat-label>Exchange Rate</mat-label>
				<input matInput formControlName="exrate" type="number" step="0.0001" min="0" appSelectOnFocus>
			</mat-form-field>
		</div>

		<div class="col-md-3">
			<mat-form-field appearance="outline" class="full-width">
				<mat-label>Reference</mat-label>
				<input matInput formControlName="reference" />
			</mat-form-field>
		</div>
		<div class="col-md-3">
			<mat-form-field appearance="outline" class="full-width">
				<mat-label>Check #</mat-label>
				<input matInput formControlName="checkno" />
			</mat-form-field>
		</div>
		<div class="col-md-6">
			<mat-form-field appearance="outline" class="full-width">
				<mat-label>Description</mat-label>
				<input matInput formControlName="description" />
			</mat-form-field>
		</div>

		<div class="col-md-3">
			<mat-form-field appearance="outline" class="full-width">
				<mat-label>Discount</mat-label>
				<input matInput formControlName="discount" type="number" step="0.01" min="0" appSelectOnFocus>
				<span matSuffix>%</span>
			</mat-form-field>
		</div>
		<div class="col-md-3">
			<mat-form-field appearance="outline" class="full-width">
				<mat-label>Amount</mat-label>
				<span matPrefix>$&nbsp;</span>
				<input matInput formControlName="amount" type="number" step="0.01" min="0" appSelectOnFocus>
			</mat-form-field>
		</div>
		<div class="col-md-6 d-flex align-items-center justify-content-end">
			<button mat-flat-button color="accent" (click)="addPayment()">Add Payment</button>
		</div>
	</div>

	<!-- Batch table -->
	<div class="row mt-3">
		<div class="col-12">
			<h5 class="text-right mb-1"><b>Total Batch Posting:</b> {{ total_payments | currency }}</h5>
			<mat-divider></mat-divider>
			<table class="table table-sm table-fixed mt-2">
				<thead>
					<tr>
						<th>Type</th>
						<th>Description</th>
						<th>Account</th>
						<th class="text-center">Disc</th>
						<th class="text-right">Amount</th>
						<th class="text-right">Total</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let pay of payments">
						<td>{{ pay.payment_type }}</td>
						<td>{{ pay.description }}</td>
						<td>{{ pay.bankaccount }}</td>
						<td class="text-center">{{ pay.discount }}%</td>
						<td class="text-right">{{ pay.amount | currency }}</td>
						<td class="text-right">{{ getPaymentTotal(pay) | currency }}</td>
						<td>
							<button mat-icon-button color="warn" (click)="removePayment(pay)">
								<mat-icon>remove_circle_outline</mat-icon>
							</button>
						</td>
					</tr>
					<tr *ngIf="!payments.length">
						<td colspan="7" class="text-center text-muted py-2">No postings added yet</td>
					</tr>
				</tbody>
			</table>
			<mat-divider></mat-divider>
			<div class="mt-3 text-right">
				<button mat-stroked-button type="button" color="primary" class="mr-2" (click)="openGlPreview()">Preview GL</button>
				<button mat-stroked-button type="button" class="mr-2" (click)="openRemittancePreview()">Preview Remittance</button>
				<button mat-flat-button color="accent" (click)="$event.preventDefault(); postPayments()">
					<mat-icon>account_balance</mat-icon> Post Payments
				</button>
			</div>
		</div>
	</div>

	<!-- AP remittance import: drop the vendor's remit/draft detail, matched lines
	     pre-fill the invoice allocations below instead of hand-ticking each one. -->
	<div class="row mt-4" *ngIf="vendor && vendor.supplierid">
		<div class="col-md-12">
			<app-ap-remittance-import #apRemit [vendor]="vendor" [bankRecContext]="bankRecContext"
				(apply)="applyApRemit($event)" (openChange)="apRemitOpen = $event"
				(postNow)="postFromRemit()"></app-ap-remittance-import>
		</div>
	</div>

	<!-- Allocate payments section. Hidden while the remittance importer is open —
	     drop mode is its own workflow, and on vendors with thousands of open
	     invoices this table is noise (or fails to load at all). Collapse the
	     importer to get it back. -->
	<div class="row mt-4" *ngIf="vendor && vendor.supplierid && !apRemitOpen">
		<div class="col-md-12">
			<mat-card>
				<mat-card-header>
					<mat-card-title>Allocate Payments &amp; Credits to Invoices</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<!-- Both panes are virtual-scrolled. THUB on Cleve carries ~2,200 open
					     invoices and ~1,900 open credits; the old plain *ngFor built a
					     mat-form-field(outline) per row and locked the tab up for minutes.
					     Only the visible rows exist in the DOM now, and the filter boxes are
					     what makes a 2,200-row ledger navigable at all. -->
					<div class="row">
						<div class="col-6">
							<h6>Payments &amp; Credits Available</h6>
							<b>Total Available:</b> {{ allocation_from_total | currency }}
							<small class="text-muted ml-2">{{ filteredFrom.length }} of {{ availableFrom.length }} shown</small><br />
							<input type="text" class="alloc-filter" placeholder="Filter credits &amp; payments (ref, transno, date, amount)"
								aria-label="Filter available payments and credits"
								[value]="fromFilter" (input)="applyFromFilter($any($event.target).value)" />
							<div class="text-left border rounded light-border scrolling-left p-2">
								<cdk-virtual-scroll-viewport class="alloc-vp" [itemSize]="rowHeight" *ngIf="filteredFrom.length">
									<div class="row border-bottom p-1 alloc-row" *cdkVirtualFor="let cred of filteredFrom; trackBy: trackByTransId">
										<div class="col-md-1">
											<mat-checkbox [checked]="cred.selected" (change)="allocationFrom($event.checked, cred)"></mat-checkbox>
										</div>
										<div class="col-md-4 alloc-meta">
											<span class="alloc-date">{{ cred.trandate }}</span>
											<span class="alloc-type">{{ cred.typename }} #{{ cred.transno }}</span>
											<span class="alloc-ref">{{ cred.suppreference }}</span>
										</div>
										<div class="col-md-4 alloc-input-cell">
											<span class="alloc-prefix">$</span>
											<input type="text" class="alloc-input" placeholder="0.00" aria-label="Allocation Amount"
												[value]="cred.allocation" (input)="updateAllocationFrom($any($event.target).value, cred)" />
										</div>
										<div class="col-md-3 text-right alloc-avail">
											<small>Available:<br />{{ cred.leftto | currency }}</small>
										</div>
									</div>
								</cdk-virtual-scroll-viewport>
								<div *ngIf="!filteredFrom.length" class="text-center p-3">
									<small class="text-muted">{{ availableFrom.length ? 'No credits or payments match the filter' : 'No available payments or credits' }}</small>
								</div>
							</div>
						</div>
						<div class="col-6">
							<h6>Outstanding Invoices</h6>
							<b>Total Selected:</b> {{ allocation_to_total | currency }}
							<small class="text-muted ml-2">{{ allocations_to.length }} selected &middot; {{ filteredInvoices.length }} of {{ vendorInvoices.length }} shown</small><br />
							<b>Remaining:</b> {{ allocation_from_total - allocation_to_total | currency }}<br />
							<input type="text" class="alloc-filter" placeholder="Filter invoices (ref, transno, date, amount)"
								aria-label="Filter outstanding invoices"
								[value]="invoiceFilter" (input)="applyInvoiceFilter($any($event.target).value)" />
							<div class="text-left border rounded light-border scrolling-left p-2">
								<cdk-virtual-scroll-viewport class="alloc-vp" [itemSize]="rowHeight" *ngIf="filteredInvoices.length">
									<div class="row border-bottom p-1 alloc-row" *cdkVirtualFor="let inv of filteredInvoices; trackBy: trackByTransId">
										<div class="col-md-1">
											<mat-checkbox [checked]="inv.selected" (change)="allocationTo($event.checked, inv)"></mat-checkbox>
										</div>
										<div class="col-md-4 alloc-meta">
											<span class="alloc-date">{{ inv.trandate }}</span>
											<span class="alloc-type">{{ inv.typename }} #{{ inv.transno }}</span>
											<span class="alloc-ref">{{ inv.suppreference }}</span>
										</div>
										<div class="col-md-4 alloc-input-cell">
											<span class="alloc-prefix">$</span>
											<input type="text" class="alloc-input" placeholder="0.00" aria-label="Allocation Amount"
												[value]="inv.allocation" (input)="updateAllocationTo($any($event.target).value, inv)" />
										</div>
										<div class="col-md-3 text-right alloc-avail">
											<small>Due:<br />{{ inv.leftto | currency }}</small>
										</div>
									</div>
								</cdk-virtual-scroll-viewport>
								<div *ngIf="!filteredInvoices.length" class="text-center p-3">
									<small class="text-muted">{{ vendorInvoices.length ? 'No invoices match the filter' : 'No outstanding invoices' }}</small>
								</div>
							</div>
						</div>
					</div>
					<div class="row mt-3">
						<div class="col-md-12 text-right">
							<button mat-flat-button color="accent" (click)="allocatePayments()">
								<mat-icon>account_balance</mat-icon> Allocate Payments
							</button>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
	</div>

</form>
